module.exports = __webpack_public_path__ + "img/z_coffee.229e0146.jpg";